import {  ViewContainerRef,ComponentRef, Type, Injectable } from '@angular/core'
import { Subject,  } from 'rxjs';
import {AddNewEventsComponent} from '../../resources-view-calendar/add-new-events/add-new-events.component'
import { AddNewEventsAssociateComponent } from 'src/app/resources-view-calendar/add-new-events-copy/add-new-events-associate.component';
import { ShowMessageComponent } from 'src/app/shared/modal/show_message/show-message.component';
import { SearchEventsComponent } from 'src/app/shared/modal/search-events/search-events.component';
import { SeriesEventsComponent } from 'src/app/shared/modal/series-events/series-events.component';
import { ShareEventsComponent } from 'src/app/shared/modal/share-events/share-events.component';
import { SearchCustomerComponent } from 'src/app/shared/modal/search-customer/search-customer/search-customer.component';
import { SearchBudgetComponent } from 'src/app/shared/modal/search-budget/search-budget.component';


@Injectable({
    providedIn: 'root'
  })
export class ModalService {
    private componentRef!: ComponentRef<AddNewEventsComponent>;
    private componentAssociateRef!: ComponentRef<AddNewEventsAssociateComponent>;
    private messagecomponentRef!: ComponentRef<ShowMessageComponent>;
    private searchcomponentRef: ComponentRef<SearchEventsComponent>;
    private seriescomponentRef: ComponentRef<SeriesEventsComponent>;
    private sharecomponentRef: ComponentRef<ShareEventsComponent>;
    private searchCustomerscomponentRef: ComponentRef<SearchCustomerComponent>; 
    private searchBudgetcomponentRef: ComponentRef<SearchBudgetComponent>;                            
    private componentSubscriber!: Subject<any>;
    private componentAssociateSubscriber!: Subject<any>;
    private componentMessageSubscriber!: Subject<any>;
    private componentSearchSubscriber!: Subject<any>;
    private componentSeriesSubscriber!: Subject<any>;
    private componentShareSubscriber!: Subject<any>;
    private componentSearchCustomerSubscriber!: Subject<any>
    private componentSearchBudgetSubscriber!: Subject<any>
    constructor() {}
  
    openModal(entry: ViewContainerRef,component: Type<any>, calendarDetails?:any) {

      this.componentRef = entry.createComponent(component); 
      this.componentRef.instance.calendarDetails=calendarDetails;

      this.componentRef.instance.closeMeEvent.subscribe((res) =>this.closeModal(entry));
      this.componentRef.instance.submitModal.subscribe((res) => {this.confirm(res,entry)});
      this.componentRef.instance.deleteMeEvent.subscribe((res) =>{this.delete(res)})
      this.componentSubscriber = new Subject<any>();
      return this.componentSubscriber.asObservable();
    }

    openModalorg(entry: ViewContainerRef,component: Type<any>, modalTitle: string, description: string, startTimeWorkplace?: any , dateDefault?: any, endDate?:any, nameresourceId?:any, resourceId?:any, calendarsNamesArr?: Array<any>, allDay?:boolean, idDetail?: any , resourceIds?:Array<any>, repeatParams?:any, currentDateRepeat?:any, extendedProps?:any, workPlaceName?:any, servicesIds?: Array<any>, customer?:any, taskIds?:any, workPlace?:any) {

      this.componentRef = entry.createComponent(component);
      this.componentRef.instance.workPlaceName = workPlaceName;
      this.componentRef.instance.title = modalTitle;
      this.componentRef.instance.description = description;
      this.componentRef.instance.dateDefault= dateDefault;
      this.componentRef.instance.endDate= endDate;
      this.componentRef.instance.resourceId = resourceId;
      this.componentRef.instance.nameresourceId = nameresourceId;
      this.componentRef.instance.calendarsNamesArr = calendarsNamesArr;
      this.componentRef.instance.idDetail= idDetail;
      this.componentRef.instance.allDay= allDay;
      this.componentRef.instance.resourceIds= resourceIds;
      this.componentRef.instance.repeatParams=repeatParams;
      this.componentRef.instance.startTimeWorkplace=startTimeWorkplace;
      this.componentRef.instance.currentDateRepeat= currentDateRepeat;
      this.componentRef.instance.extendedProps=extendedProps;
      this.componentRef.instance.servicesIds= servicesIds;
      this.componentRef.instance.customerInfo= customer;
      this.componentRef.instance.taskIds = taskIds;
      this.componentRef.instance.workPlace= workPlace;

      this.componentRef.instance.closeMeEvent.subscribe(() => this.closeModal());
      this.componentRef.instance.submitModal.subscribe((res) => {this.confirm(res)});
      this.componentRef.instance.deleteMeEvent.subscribe((res) =>{this.delete(res)})
      this.componentSubscriber = new Subject<any>();
      return this.componentSubscriber.asObservable();
    }

    openModalAssociate(entry: ViewContainerRef,component: Type<any>, modalTitle: string, description: string, startTimeWorkplace?: any , dateDefault?: any, endDate?:any, nameresourceId?:any, resourceId?:any, calendarsNamesArr?: Array<any>, allDay?:boolean, idDetail?: any , resourceIds?:Array<any>, repeatParams?:any, currentDateRepeat?:any, extendedProps?:any, workPlaceName?:any) {
     
      this.componentAssociateRef = entry.createComponent(component);
      this.componentAssociateRef.instance.workPlaceName = workPlaceName;
      this.componentAssociateRef.instance.title = modalTitle;
      this.componentAssociateRef.instance.description = description;
      this.componentAssociateRef.instance.dateDefault= dateDefault;
      this.componentAssociateRef.instance.endDate= endDate;
      this.componentAssociateRef.instance.resourceId = resourceId;
      this.componentAssociateRef.instance.nameresourceId = nameresourceId;
      this.componentAssociateRef.instance.calendarsNamesArr = calendarsNamesArr;
      this.componentAssociateRef.instance.idDetail= idDetail;
      this.componentAssociateRef.instance.allDay= allDay;
      this.componentAssociateRef.instance.resourceIds= resourceIds;
      this.componentAssociateRef.instance.repeatParams=repeatParams;
      this.componentAssociateRef.instance.startTimeWorkplace=startTimeWorkplace;
      this.componentAssociateRef.instance.currentDateRepeat= currentDateRepeat;
      this.componentAssociateRef.instance.extendedProps=extendedProps

      this.componentAssociateRef.instance.closeMeEvent.subscribe(() => this.closeModal());
      this.componentAssociateRef.instance.submitModal.subscribe((res) => {this.confirm(res)});
      this.componentAssociateRef.instance.deleteMeEvent.subscribe((res) =>{this.delete(res)})
      this.componentAssociateSubscriber = new Subject<any>();
      return this.componentAssociateSubscriber.asObservable();
    }

  

    openModalShowMessage(entry: ViewContainerRef,component: Type<any>, message: string, action: string, extras?: { showNotifyButton?: boolean }){
      this.messagecomponentRef = entry.createComponent(component);
      this.messagecomponentRef.instance.message = message;
      this.messagecomponentRef.instance.action=action;
      if (extras && extras.showNotifyButton !== undefined) this.messagecomponentRef.instance.showNotifyButton = extras.showNotifyButton;
      this.messagecomponentRef.instance.closeMessageEvent.subscribe(() => this.closeMessageModal());
      this.messagecomponentRef.instance.cancelMessageEvent.subscribe((res) => {this.cancelMessage(res)});
      this.messagecomponentRef.instance.deleteMessageEvent.subscribe((res) =>{this.deleteMessage(res)});
      this.messagecomponentRef.instance.confirmMessageEvent.subscribe((res) =>{this.confirmEvent(res)});
      this.componentMessageSubscriber = new Subject<any>();
      return this.componentMessageSubscriber.asObservable();
    }

    openModalSearchEvents(entry: ViewContainerRef,component: Type<any>, id: any, view: any, workPlace:any){
      this.searchcomponentRef = entry.createComponent(component);
      this.searchcomponentRef.instance.idWorkPlace = id;
      this.searchcomponentRef.instance.view = view;
      this.searchcomponentRef.instance.workPlace = workPlace;
      this.searchcomponentRef.instance.confirmMessageEvent.subscribe((res) => {this.confirmMessageEvent(res)})
      this.searchcomponentRef.instance.closeMessageEvent.subscribe((res) => {this.closeSearchEventsModal(res)});
      this.searchcomponentRef.instance.cancelMessageEvent.subscribe((res) => {this.cancelSearchEvents(res)});
      this.componentSearchSubscriber = new Subject<any>();
      return this.componentSearchSubscriber.asObservable();
    }

    openModalSeriesEvents(entry: ViewContainerRef,component: Type<any>,action:any, messageA: any, messageB:any, messageC:any){
      this.seriescomponentRef = entry.createComponent(component);
      this.seriescomponentRef.instance.typeAction=action;
      this.seriescomponentRef.instance.messageA=messageA;
      this.seriescomponentRef.instance.messageB= messageB;
      this.seriescomponentRef.instance.messageC= messageC;
      this.seriescomponentRef.instance.seriesConfirmEvent.subscribe((res) => {this.confirmSeriesEvents(res)})
      this.seriescomponentRef.instance.seriesCancelEvent.subscribe((res) => {this.cancelSeriesEvents(res)})
      this.seriescomponentRef.instance.seriesCloseEvent.subscribe((res) => {this.closeSeriesEvents(res)})
      this.componentSeriesSubscriber = new Subject<any>();
      return this.componentSeriesSubscriber.asObservable();
    }

       
    openModalShareEvents(entry: ViewContainerRef,component: Type<any>, htmlMessage, workPlaceName, phone){
      this.sharecomponentRef = entry.createComponent(component);
      this.componentShareSubscriber = new Subject<any>();
      this.sharecomponentRef.instance.htmlMessage=htmlMessage;
      this.sharecomponentRef.instance.phone=phone
      this.sharecomponentRef.instance.workPlaceName= workPlaceName;
      this.sharecomponentRef.instance.closeShareEvent.subscribe((res)=>{this.closeShareEvents(res)})
      return this.componentShareSubscriber.asObservable();
    }

    openModalSearchCustomers(entry: ViewContainerRef,component: Type<any>, criteria?, enterprise?){
      this.searchCustomerscomponentRef = entry.createComponent(component);
     // this.searchCustomerscomponentRef.instance.confirmMessageEvent.subscribe((res) => {this.confirmMessageEvent(res)})
      this.searchCustomerscomponentRef.instance.criteria=criteria;
      this.searchCustomerscomponentRef.instance.enterprise=enterprise;
      this.searchCustomerscomponentRef.instance.closeCustomerSearch.subscribe((res) => {this.closeSearchCustomer(res)});
     // this.searchCustomerscomponentRef.instance.cancelMessageEvent.subscribe((res) => {this.cancelSearchEvents(res)});
      this.componentSearchCustomerSubscriber = new Subject<any>();
      return this.componentSearchCustomerSubscriber.asObservable();
    }

    openModalSearchBudget(entry: ViewContainerRef,component: Type<any>, criteria?, enterprise?){
      this.searchBudgetcomponentRef = entry.createComponent(component);
      this.searchBudgetcomponentRef.instance.criteria=criteria;
      this.searchBudgetcomponentRef.instance.enterprise=enterprise;
      this.searchBudgetcomponentRef.instance.closeBudgetSearch.subscribe((res) => {this.closeSearchBudget(res)});
 //     this.searchBudgetcomponentRef.instance.cancelMessageEvent.subscribe((res) => {this.cancelSearchEvents(res)});
      this.componentSearchBudgetSubscriber = new Subject<any>();
      return this.componentSearchBudgetSubscriber.asObservable();
    }



    closeModal(entry?:ViewContainerRef) {
      if(this.componentSubscriber)
        this.componentSubscriber.complete();
      if(this.componentRef){
        console.log('entra para hacer el componentref destroy')
        this.componentRef.destroy();
      }
      console.log(entry,'entry 1')
      if (entry) {
        console.log(entry,'entry 2')
        entry.clear(); // Limpiar ViewContainerRef
      }
      
    }
  
    confirm(value:any,entry?:ViewContainerRef) {
      // confirm() called
      try{
        if (this.componentSubscriber) {
          this.componentSubscriber.next(value);
          // componentSubscriber.next() called
        } else {
          console.warn('ModalService: no componentSubscriber to next');
        }
      } catch(e){ console.warn('ModalService: error during componentSubscriber.next()', e) }
      try{
        this.closeModal(entry);
        // closeModal() called from confirm()
        try{ window.dispatchEvent(new CustomEvent('calendar:refresh')); }catch(e){/* ignore */}
      } catch(e){ console.warn('ModalService: error during closeModal()', e) }
    }

    delete(value: any)
    { 
        this.componentSubscriber.next(value); 
        this.closeModal();
    }

    cancel(value: any)
    {this.componentSubscriber.next(value);
      this.closeModal();}

    closeMessageModal(){
        // closeMessageModal()
        if (this.componentMessageSubscriber) {
          try{ this.componentMessageSubscriber.complete(); } catch(e){ console.warn('ModalService: complete() error', e) }
        }
      if (this.messagecomponentRef) {
        try{ this.messagecomponentRef.destroy(); } catch(e){ console.warn('ModalService: destroy() error', e) }
      }
     }

    deleteMessage(value: any)
     {
         // deleteMessage received
         const localSubscriber = this.componentMessageSubscriber;
         const localRef = this.messagecomponentRef;
         // clear global refs so opening a new modal won't be affected by the async cleanup below
         this.componentMessageSubscriber = undefined as any;
         this.messagecomponentRef = undefined as any;
         try{ if (localRef) localRef.destroy(); } catch(e){ console.warn('ModalService: destroy() error', e) }
         setTimeout(()=>{
           try{ if (localSubscriber) localSubscriber.next(value); } catch(e){ console.warn('ModalService: next() error', e) }
           try{ if (localSubscriber) localSubscriber.complete(); } catch(e){ console.warn('ModalService: complete() error', e) }
         },0);
     }

    cancelMessage(value: any)
     {
      console.log('ModalService: cancelMessage received', value);
      const localSubscriber = this.componentMessageSubscriber;
      const localRef = this.messagecomponentRef;
      this.componentMessageSubscriber = undefined as any;
      this.messagecomponentRef = undefined as any;
      try{ if (localRef) localRef.destroy(); } catch(e){ console.warn('ModalService: destroy() error', e) }
      setTimeout(()=>{
        try{ if (localSubscriber) localSubscriber.next(value); } catch(e){ console.warn('ModalService: next() error', e) }
        try{ if (localSubscriber) localSubscriber.complete(); } catch(e){ console.warn('ModalService: complete() error', e) }
      },0);
      }

    confirmMessageEvent(value:any) {
        this.componentSubscriber.complete();
        this.componentRef.destroy();
        this.componentSubscriber.next(value);
        this.componentSearchSubscriber.complete();
      }
  

    closeSearchEventsModal(value: any){
      this.componentSearchSubscriber.next(value)
      this.componentSearchSubscriber.complete();
      this.searchcomponentRef.destroy();
     }

    cancelSearchEvents(value: any)
     {
      this.componentSearchSubscriber.next(value);
      this.componentSearchSubscriber.complete();
      this.searchcomponentRef.destroy();
      this.closeSearchEventsModal(value);}

    closeSeriesEvents(value: any){
        this.componentSeriesSubscriber.next(value)
        this.componentSeriesSubscriber.complete();
        this.seriescomponentRef.destroy();
    }

    cancelSeriesEvents(value: any){
      this.componentSeriesSubscriber.next(value);
      this.componentSeriesSubscriber.complete();
      this.seriescomponentRef.destroy()
    }

    confirmSeriesEvents(value: any){
      this.componentSeriesSubscriber.next(value);
      this.componentSeriesSubscriber.complete();
      this.seriescomponentRef.destroy()

    }

    confirmEvent(value:any){
      console.log('ModalService: confirmEvent received', value);
      const localSubscriber = this.componentMessageSubscriber;
      const localRef = this.messagecomponentRef;
      this.componentMessageSubscriber = undefined as any;
      this.messagecomponentRef = undefined as any;
      try{ if (localRef) localRef.destroy(); } catch(e){ console.warn('ModalService: destroy() error', e) }
      setTimeout(()=>{
        try{ if (localSubscriber) localSubscriber.next(value); } catch(e){ console.warn('ModalService: next() error', e) }
        try{ if (localSubscriber) localSubscriber.complete(); } catch(e){ console.warn('ModalService: complete() error', e) }
      },0);

    }

    confirmShare(value:any){
      this.componentShareSubscriber.next(value);
      this.componentShareSubscriber.complete();
      this.sharecomponentRef.destroy()
    }

    cancelShareEvents(value: any)
    {
     this.componentShareSubscriber.next(value);
     this.componentShareSubscriber.complete();
     this.sharecomponentRef.destroy();
     this.closeShareEvents(value);}

     closeShareEvents(value: any){
      this.componentShareSubscriber.next(value)
      this.componentShareSubscriber.complete();
      this.sharecomponentRef.destroy();
  }

    closeSearchCustomer(value:any){
      this.componentSearchCustomerSubscriber.next(value)
      this.componentSearchCustomerSubscriber.complete();
      this.searchCustomerscomponentRef.destroy();
    }

    closeSearchBudget(value:any){
      this.componentSearchBudgetSubscriber.next(value)
      this.componentSearchBudgetSubscriber.complete();
      this.searchBudgetcomponentRef.destroy();
    }


       
}